import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import ResponsiveSubPage from "../../../common/core/ResponsiveSubPage";
import { ToggleSurface } from "../../../common/core/Surface";
import AssistanceSection from "../../../common/sections/AssistanceSection";
import { useMissionTask } from "../../../../providers/MissionTaskProvider";
import NotFoundPage from "../../error/NotFoundPage";
import config from "../../../../config";
import GoToMyMissionsDialog from "../common/GoToMyMissionsDialog";
import { useDevice } from "../../../../providers/DeviceProvider";
import { NavLink } from "react-router-dom";
import { Button } from "@mui/material";
import { TaskEnums } from "../../../../common/constants";


const useStyles = makeStyles()(
  (theme) => ({
    startNavButton: {
      position: "absolute",
      right: theme.spacing(1),
      bottom: theme.spacing(1),
      zIndex: 1,
      "& button": {
        borderRadius: `${theme.spacing(1.5)} !important`
      }
    }
  })
);

export default function MissionTaskAssistancePage() {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { continueMission, continueMissionText, notFound, driverAssignedState } = useMissionTask();
  const { isMobile } = useDevice();

  return notFound ? (
    <NotFoundPage backPath="../" />
  ) : (
    <ResponsiveSubPage
      title={t("taskAssistancePage:title")}
      maxWidth={config.pageSize.small}
      backPath="../"
      backButton
      secondaryAction={continueMissionText}
      onSecondaryAction={continueMission}
    >
      <ToggleSurface xs={12}>
        <AssistanceSection showDetails >
          {
            isMobile && driverAssignedState === TaskEnums.DriverAssignedState.Accepted ? (
              <NavLink to="../navigation" className={classes.startNavButton}>
                <Button variant="contained" color="primary">
                  {t("task:common:startNavigation")}
                </Button>
              </NavLink>
            ) : null
          }
        </AssistanceSection>
      </ToggleSurface>

      <GoToMyMissionsDialog />

    </ResponsiveSubPage>
  );
}
